import styled from 'styled-components';

export const GrandHeading = styled.h1`
  font-family: Circular-Bold;
  color: #253858;
  margin-bottom: 16px;
  font-size: 3rem;
  line-height: 1.25;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 2rem;
    line-height: 1.25;
    margin-bottom: 14px;
    br {
      display: none;
    }
  }
`;

export const Heading = styled.h2`
  font-family: Circular-Bold;
  font-size: 2.25rem;
  color: #253858;
  margin-bottom: 14px;
  @media (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 1.33333333;
    br {
      display: none;
    }
  }
`;

export const SubHeading = styled.p`
  font-family: Circular-Book;
  font-size: 1.5rem;
  color: #42526E;
  @media (max-width: 768px) {
    font-size: 1.25rem;
    line-height: 1.2;
    text-align: center;
    br {
      display: none;
    }
  }
`;
